module.exports = __webpack_public_path__ + "img/violet_052.94e5c3ad.png";